import React from "react";

const CallToAction = ({ blok }) => {
  return (
    <div className="bg-cyan-light">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-24 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl font-extrabold tracking-tight text-white md:text-4xl">
          <span className="block text-black">{blok.title}</span>
          <span className="block text-cyan-dark">{blok.subtitle}</span>
        </h2>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
          <div className="inline-flex rounded-md shadow">
            <a
              href={blok.buttonLink.url}
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-black bg-amber hover:bg-amber-dark"
            >
              {blok.buttonText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
